import { render, unmount as reactUnmount } from './render';
export function renderToBody(element) {
    var container = document.createElement('div');
    document.body.appendChild(container);
    function unmount() {
        var unmountResult = reactUnmount(container);
        if (unmountResult && container.parentNode) {
            container.parentNode.removeChild(container);
        }
    }
    render(element, container);
    return unmount;
}
